import React, { useState } from "react";
import ClickOutside from "react-outside-click-handler";
import { useTransition, animated } from "react-spring";
import ClassNames from "classnames";
import * as s from "./s.module.scss";
import Scrollbar from "../Scrollbar";
// Icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const Select = ({
  selectedOption,
  options,
  onOptionClick,
  selectedHolderStyle,
  selectedHolderClass,
  selectedOptionStyle,
  selectedOptionClass,
  selectContainerClass,
  selectContainerStyle,
  optionContainerClass,
  optionContainerStyle,
  optionFontSize
}) => {
  const [active, setActive] = useState(false);

  const config = { mass: 1, tension: 2000, friction: 100 };

  const transitions = useTransition(active, null, {
    config,
    from: { opacity: 0, transform: "scale(0.96)" },
    enter: { opacity: 1, transform: "scale(1)" },
    leave: { opacity: 0, transform: "scale(0.96)" }
  });
  return (
    <ClickOutside onOutsideClick={() => setActive(false)}>
      <div
        className={ClassNames(s.selectContainer, selectContainerClass)}
        style={selectContainerStyle}
      >
        <div
          className={ClassNames(
            s.selectedHolder,
            { [s.active]: active },
            { [s.big]: optionFontSize === "big" },
            selectedHolderClass
          )}
          onClick={() => setActive(!active)}
          style={selectedHolderStyle}
        >
          <span className={selectedOptionClass} style={selectedOptionStyle}>
            {selectedOption.value}
          </span>
          <FontAwesomeIcon icon={faChevronDown} />
        </div>
        {transitions.map(({ item, key, props }) => {
          return (
            item && (
              <animated.div
                style={{
                  ...props,
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  transformOrigin: "top left",
                  zIndex: 3,
                  width: "100%"
                }}
                key={key}
              >
                <div
                  className={ClassNames(s.optionsContainer, optionContainerClass)}
                  style={optionContainerStyle}
                >
                  <Scrollbar>
                    {options.map((option, i) => (
                      <div
                        className={ClassNames(s.optionList, {
                          [s.selected]: selectedOption.label === option.label
                        })}
                        key={i}
                        onClick={({ selected }) => {
                          setActive(false);
                          if (selectedOption.label !== option.label) {
                            selected = option;
                            onOptionClick({ selected });
                          }
                        }}
                      >
                        {option.value}
                      </div>
                    ))}
                  </Scrollbar>
                </div>
              </animated.div>
            )
          );
        })}
      </div>
    </ClickOutside>
  );
};

export default Select;
